import React, { useContext } from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { UpFlowContext } from '@confluence/change-edition/entry-points/UpFlowProvider.ts';

const LazyExperimentPlanSelectionModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExperimentPlanSelectionModal" */ './ExperimentPlanSelectionModal.tsx'
			)
		).ExperimentPlanSelectionModal,
});

export const TrialPlanComparisonModalMountComponent = (): React.JSX.Element => {
	const { currentEdition } = useContext(UpFlowContext);
	return <>{currentEdition === ConfluenceEdition.FREE && <LazyExperimentPlanSelectionModal />}</>;
};
